var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Checkbox, Grid, Typography } from "@material-ui/core";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import MarkdownText from "./MarkdownText";
var VertCenteredGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: center;\n"], ["\n  align-self: center;\n"])));
var MarkdownTextWithoutMargin = styled(MarkdownText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  p {\n    margin: 0;\n  }\n"], ["\n  p {\n    margin: 0;\n  }\n"])));

var CheckboxOption = function CheckboxOption(_a) {
  var item = _a.item;
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var dispatch = useDispatch();
  var option = item.options[0];
  var _b = option.texts[0],
      body = _b.body,
      title = _b.title;

  var toggle = function toggle() {
    return dispatch(quizAnswerActions.changeCheckboxData(item.id, option.id));
  };

  var answerLocked = userQuizState && userQuizState.status === "locked" ? true : false;
  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });

  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }

  var optionAnswer = itemAnswer && itemAnswer.optionAnswers[0];
  var checkboxOptions = {
    disabled: answerLocked || quizDisabled,
    checked: optionAnswer !== undefined && !quizDisabled
  };
  return React.createElement(Grid, {
    container: true,
    style: {
      marginBottom: 10
    }
  }, React.createElement(Grid, {
    item: true,
    xs: 1
  }, React.createElement(Checkbox, __assign({
    value: optionAnswer ? optionAnswer.quizOptionId : "",
    color: "primary",
    onChange: toggle
  }, checkboxOptions))), React.createElement(VertCenteredGrid, {
    item: true,
    xs: true
  }, title && React.createElement(MarkdownTextWithoutMargin, {
    Component: Typography,
    variant: "subtitle1"
  }, title), body && body !== title && React.createElement(MarkdownTextWithoutMargin, {
    Component: Typography,
    variant: "body1"
  }, body)));
};

export default CheckboxOption;
var templateObject_1, templateObject_2;